import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import InsightChip from './InsightChip';

const useStyles = buildUseStyles('OutcomeInsights', ((theme) => ({
  root: {
    padding: theme.spacing(0, 1),
    display: 'flex',
    gap: `${theme.spacing(1)}px`,
    flexWrap: 'wrap',
    alignContent: 'center',
    flexShrink: 0,
  },
})));

const OutcomeInsights = ({
  relationshipCollection,
}) => {
  const classes = useStyles();
  return (
    <Box
      className={classes.root}
    >
      {
        relationshipCollection.resources().list().map((insightResource) => (
          <InsightChip
            key={insightResource.id()}
            insightResource={insightResource}
          />
        ))
      }

    </Box>
  );
};

OutcomeInsights.defaultProps = {
};

OutcomeInsights.propTypes = {
  relationshipCollection: PropTypes.object.isRequired,
};

export default OutcomeInsights;
